export default () => ({
  list: [],
  all: [],
  company: {},
  business: [],
  size: {
    1: '１～１０人',
    2: '１１～２９人',
    3: '３０～４９人',
    4: '５０～９９人',
    5: '１００～４９９人',
    6: '５００～９９９人',
    7: '１０００人以上',
  },
  form: {
    1: '株式会社',
    2: '合同会社',
    3: '合資会社',
    4: '合名会社',
    5: '個人事業主',
    6: '未設定',
  },
  appliction_form: {
    7: '法人経営者',
    8: '個人事業主・フリーランス・副業',
    9: '法人等の従業員',
  },
  job_description: {
    1: '経営企画',
    2: '営業',
    3: '販売',
    4: 'マーケティング',
    5: '広報・宣伝',
    6: '事業開発',
    7: '総務',
    8: '法務',
    9: '人事',
    10: '教育',
    11: '財務',
    12: '経理',
    13: '一般事務',
    14: '生産・製造',
    15: '資材・購買',
    16: '配送・物流',
    17: '保守・サポート',
    18: 'エンジニア（IT系）',
    19: 'エンジニア（非IT系）',
    20: '情報処理・情報システム',
    21: '研究・開発',
    22: '編集・編成・制作・デザイン',
    23: '建築・土木関連',
    24: '医療関連',
    25: '会計関連',
    26: '法律関連',
    27: '教育関連',
    28: 'その他',
  },
  similar_position: {
    1: '役員',
    2: '事業部長・執行役員・工場長',
    3: '部長・課長',
    4: '係長・主任',
    5: '一般社員',
    6: '契約社員・嘱託職員・派遣社員',
    7: 'その他',
  },
  favorite: {
    1: '補助金・助成金',
    2: '起業・会社設立',
    3: '労務',
    4: '法務',
    5: '勤怠管理',
    6: '経費精算',
    7: '人材採用',
    8: '請求',
    9: 'ワークフロー',
    10: 'コスト削減',
    11: 'M&A・事業承継',
    12: '融資',
    13: '資金繰り',
    14: '会計・税金',
    15: '管理・総務',
    16: '人事・給与',
    17: 'SaaS一般',
    18: 'HRテック',
    19: 'リーガルテック',
    20: '顧客管理',
    21: 'グループウェア',
    22: 'CRM／SFA',
    23: '出資',
    24: '広報・PR',
    25: '営業',
    26: 'マーケティング',
    27: '海外進出',
    28: '教育',
    29: '転職',
    30: '生産管理',
    31: '建築・建設',
    32: '販売管理',
    33: '物流・倉庫',
    34: 'BI・分析',
    35: 'MA',
    36: 'セキュリティ',
    37: 'ローン',
    38: '通信・回線',
    39: '就活',
    40: '終活',
    41: '不動産購入',
    42: '車・バイク',
    43: '投資',
    44: '旅行',
    45: 'ショッピング',
    46: 'アクティビティ',
    47: '自己啓発',
    48: 'ニュース',
  },
  types: {
    0: '一般',
    1: 'テスト用',
  },
})
